module.exports = __webpack_public_path__ + "static/baked_macaron_bouquet-8853e8ccc83c47fc7d050842f67cc6d8.jpg";